/*
  Somnia | página de producto (se carga con defer solo en la sección principal de producto).
  No modifica theme.js: espera a que el tema termine de iniciar (evento page:loaded) para que sus
  listeners de variantChange queden registrados primero y los de aquí corran después.

  1. Stock por talla: con 1 a [umbral] piezas, "Quedan N en M" (texto de somnia.product.stock_low,
     que Liquid deja en data-somnia-low-one / data-somnia-low-other); con más piezas o sin inventario
     controlado, "En stock" (somnia.product.stock_in, data-somnia-instock) con el punto verde del tema.
     Sin talla elegida o agotada, ese renglón se oculta (somnia-stock-off).
  2. Tallas agotadas: el tema las tacha con la clase .disabled (siguen seleccionables). Aquí se
     mantiene sincronizado el texto oculto "agotada" para lectores de pantalla.
  3. Sin talla preseleccionada y validación al agregar al carrito (ver setupSizeChoice).
*/
(function () {
  'use strict';

  function productInstance(section) {
    if (!window.theme || !theme.sections || !theme.sections.instances) return null;
    for (var i = 0; i < theme.sections.instances.length; i++) {
      var inst = theme.sections.instances[i];
      if (inst.type === 'product' && inst.container === section) return inst;
    }
    return null;
  }

  function setupStock(section) {
    var el = section.querySelector('[data-product-inventory][data-somnia-low-one]');
    if (!el) return null;
    var productId = section.getAttribute('data-product-id');
    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 0;
    var sizeKey = el.getAttribute('data-somnia-size-option');

    var inStock = el.getAttribute('data-somnia-instock');
    return function (variant) {
      if (!variant) return;
      var text = null;
      if (variant.inventory_management === 'shopify') {
        var all = window.inventories && window.inventories[productId];
        var inv = all && all[variant.id];
        if (!inv) return;
        var qty = parseInt(inv.quantity, 10);
        if (qty > 0 && qty <= threshold) {
          var size = (sizeKey && variant[sizeKey]) || variant.title;
          var tpl = el.getAttribute(qty === 1 ? 'data-somnia-low-one' : 'data-somnia-low-other');
          text = tpl.replace('[count]', qty).replace('[size]', size);
        } else if (qty > threshold) {
          text = inStock;
        }
      } else {
        text = inStock;
      }
      /* Sin text (agotada) se deja lo del tema, que oculta el renglón */
      if (text && el.textContent !== text) el.textContent = text;
    };
  }

  /* Renglón de stock bajo las tallas ("En stock" o "Quedan N en M"): visible solo con talla elegida y con
     piezas; si no, invisible pero ocupando su alto (CSS), así nada se mueve. Corre después de theme.js, que
     ya dejó la clase inventory--low y la clase hide si la talla está agotada. */
  function syncStockBlock(section, hasChoice) {
    var block = section.querySelector('[data-somnia-stock]');
    if (!block) return;
    var item = block.querySelector('[data-somnia-stock-item]');
    var shown = !!(hasChoice && item && !item.classList.contains('hide'));
    if (item) item.classList.toggle('somnia-stock-off', !shown);
  }

  function syncSoldOut(section) {
    section.querySelectorAll('fieldset[data-somnia-soldout-text]').forEach(function (fieldset) {
      var word = fieldset.getAttribute('data-somnia-soldout-text');
      fieldset.querySelectorAll('label.variant__button-label').forEach(function (label) {
        var hint = label.querySelector('[data-somnia-soldout]');
        var soldOut = label.classList.contains('disabled');
        if (soldOut && !hint) {
          hint = document.createElement('span');
          hint.className = 'visually-hidden';
          hint.setAttribute('data-somnia-soldout', '');
          hint.textContent = word;
          label.appendChild(document.createTextNode(' '));
          label.appendChild(hint);
        } else if (!soldOut && hint) {
          if (hint.previousSibling && hint.previousSibling.nodeType === 3 && hint.previousSibling.textContent === ' ') {
            label.removeChild(hint.previousSibling);
          }
          label.removeChild(hint);
        }
      });
    });
  }

  /*
    3. Sin talla preseleccionada (cambio 13). Liquid marca el fieldset con data-somnia-size-required
       y, sin ?variant= en la URL, no marca ninguna talla. Mientras no hay talla:
       - el stock no se muestra;
       - "Agregar al carrito" no envía: aparece "Elige tu talla" y el foco va a la primera talla
         disponible. Se intercepta el submit en la sección en fase de captura, antes de que llegue al
         formulario (donde theme.js lo envía por AJAX). Respaldo: el select name="id" arranca vacío.
       Renglón de talla ([data-somnia-size-label]): "Talla: elige una", "Talla: L" o, si coincide con
       el resultado del quiz, "Tu talla: L" ("Tu talla (L) está agotada" si el quiz dio una agotada).
       Con resultado del quiz (la guía lo publica), se marca esa talla con el patrón nativo
       (radio + change). Al cargar no se aplica si la URL trae ?variant= o si ya hay talla marcada.
       Nunca se desmarcan radios.
  */
  function setupSizeChoice(section) {
    var fieldset = section.querySelector('fieldset[data-somnia-size-required]');
    if (!fieldset) return;
    var form = section.querySelector('form.product-single__form');
    var errorEl = section.querySelector('[data-somnia-size-error]');
    var labelEl = section.querySelector('[data-somnia-size-label]');
    var urlVariant = fieldset.hasAttribute('data-somnia-url-variant');
    var lastRec = null;

    function chosen() {
      return fieldset.querySelector('input[data-variant-input]:checked');
    }
    function updateLabel() {
      if (!labelEl) return;
      var r = chosen(), d = labelEl.dataset, text;
      if (r) {
        text = (lastRec && lastRec.size === r.value ? d.textYours : d.textChosen).replace('[size]', r.value);
      } else if (lastRec && lastRec.size && !lastRec.available) {
        text = d.textSoldout.replace('[size]', lastRec.size);
      } else {
        text = d.textNone;
      }
      if (labelEl.textContent !== text) labelEl.textContent = text;
    }
    function firstAvailable() {
      var inputs = fieldset.querySelectorAll('input[data-variant-input]');
      for (var i = 0; i < inputs.length; i++) {
        var label = fieldset.querySelector('label[for="' + inputs[i].id + '"]');
        if (!label || !label.classList.contains('disabled')) return inputs[i];
      }
      return inputs[0] || null;
    }

    section.addEventListener('variantChange', function () {
      if (chosen() && errorEl) errorEl.textContent = '';
      syncStockBlock(section, !!chosen());
      updateLabel();
    });

    section.addEventListener('submit', function (evt) {
      if (evt.target !== form || chosen()) return;
      evt.preventDefault();
      evt.stopPropagation();
      if (errorEl) errorEl.textContent = errorEl.getAttribute('data-text');
      var first = firstAvailable();
      if (first) first.focus();
    }, true);

    function selectSize(size) {
      var esc = window.CSS && CSS.escape ? CSS.escape(size) : size;
      var radio = fieldset.querySelector('input[data-variant-input][value="' + esc + '"]');
      if (!radio) return false;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    function applyRecommendation(rec, fromQuiz) {
      lastRec = rec || null;
      updateLabel();
      if (!rec || !rec.size || !rec.available) return;
      if (!fromQuiz && (urlVariant || chosen())) return;
      var landingUrl = window.location.href;
      if (selectSize(rec.size) && !fromQuiz && history.replaceState) {
        /* Al cargar, conserva la URL de llegada (UTM, fbclid): el tema la cambia a ?variant= al marcar */
        history.replaceState(history.state, '', landingUrl);
      }
    }

    var guide = document.getElementById('SizeGuideDrawer');
    if (guide && guide.dataset.sgRec) {
      try { applyRecommendation(JSON.parse(guide.dataset.sgRec), false); } catch (err) {}
    }
    document.addEventListener('somnia:size-recommended', function (evt) {
      applyRecommendation(evt.detail, true);
    });

    /* Para la barra fija (assets/somnia-sticky.js): misma lógica de talla, sin copiarla */
    section.somniaSize = {
      chosen: chosen,
      select: selectSize,
      rec: function () { return lastRec; }
    };
  }

  /* 4. Pestañas Detalles | Ajuste | Tela (snippets/somnia-info-tabs.liquid). Patrón de pestañas con
     activación automática: clic, flechas izquierda/derecha (con vuelta), Inicio y Fin (con una sola pestaña
     no hay fila). El contenido va recortado a unos 3 renglones (CSS); aquí se decide si hace falta "Ver más"
     (botón con aria-expanded). Abierto o cerrado es un estado del módulo, no de cada pestaña: después de
     "Ver más", todas las pestañas se ven completas hasta "Ver menos". Una pestaña que cabe en el recorte no
     muestra el botón (no hay nada que abrir o cerrar), pero el estado se conserva para las demás. Sin animación. */
  function setupTabs(section) {
    section.querySelectorAll('[data-somnia-tabs]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-somnia-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-somnia-tab-panel]'));
      var more = root.querySelector('[data-somnia-tabs-more]');
      var expanded = false;

      function active() {
        for (var i = 0; i < panels.length; i++) if (!panels[i].hidden) return panels[i];
        return null;
      }
      /* ¿El contenido cabe en el alto recortado? Se mide sin is-expanded (sin pintar en medio) */
      function fits(p) {
        var open = p.classList.contains('is-expanded');
        if (open) p.classList.remove('is-expanded');
        var ok = p.scrollHeight <= p.clientHeight + 1;
        if (open) p.classList.add('is-expanded');
        return ok;
      }
      /* Aplica el estado del módulo a la pestaña visible: degradado y botón solo si no cabe */
      function apply() {
        var p = active();
        if (!p || !more) return;
        var f = fits(p);
        p.classList.toggle('is-clamped', !f);
        p.classList.toggle('is-expanded', expanded && !f);
        more.classList.toggle('is-off', f);
        more.setAttribute('aria-controls', p.id);
        more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        more.textContent = expanded ? more.getAttribute('data-text-less') : more.getAttribute('data-text-more');
      }

      if (more) {
        more.addEventListener('click', function () {
          expanded = !expanded;
          apply();
        });
        /* Con el teclado, al entrar a contenido recortado (por ejemplo, Calcula tu talla) se abre */
        panels.forEach(function (p) {
          p.addEventListener('focusin', function (e) {
            if (e.target !== p && !expanded && p.classList.contains('is-clamped')) {
              expanded = true;
              apply();
            }
          });
        });
      }

      if (tabs.length > 1) {
        var select = function (tab, focus) {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.tabIndex = on ? 0 : -1;
            var panel = document.getElementById(t.getAttribute('aria-controls'));
            if (!panel) return;
            /* Al cambiar de pestaña se conserva abierto o cerrado (apply lo aplica a la nueva) */
            if (!on) panel.classList.remove('is-expanded');
            panel.hidden = !on;
          });
          apply();
          if (focus) tab.focus();
        };
        tabs.forEach(function (t) {
          t.addEventListener('click', function () { select(t, false); });
        });
        root.querySelector('[role="tablist"]').addEventListener('keydown', function (e) {
          var i = tabs.indexOf(document.activeElement);
          if (i < 0) return;
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') next = tabs[0];
          else if (e.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          e.preventDefault();
          select(next, true);
        });
      }

      apply();
      /* Si cambia el ancho (giro del teléfono, ventana), vuelve a medir si el contenido cabe */
      if ('ResizeObserver' in window) new ResizeObserver(function () { apply(); }).observe(root);
    });
  }

  /* 5. "Cambio de talla gratis" (snippets/somnia-shipping.liquid): baja a la pregunta de cambios de la FAQ
     (#faq-cambios, setting "ancla" de sections/faq.liquid) y la abre con el acordeón del tema si está cerrada.
     Sin la pregunta en la página, el enlace hace lo normal. */
  function setupFaqLinks(section) {
    section.querySelectorAll('[data-somnia-faq-link]').forEach(function (link) {
      link.addEventListener('click', function (evt) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        evt.preventDefault();
        var trigger = target.querySelector('.collapsible-trigger');
        if (trigger && trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
        var top = target.getBoundingClientRect().top + window.pageYOffset;
        var header = document.querySelector('.site-header');
        if (window.theme && theme.config && theme.config.stickyHeader && header) top -= header.offsetHeight;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, top - 10), behavior: reduce ? 'auto' : 'smooth' });
        if (trigger) trigger.focus({ preventScroll: true });
      });
    });
  }

  /* 6. "Ver condiciones" de la FAQ (sections/faq.liquid): abre la política de cambios en un panel con el mismo
     componente que la guía de tallas (theme.Drawers: overlay, ESC, bloqueo de scroll y foco; estilos en
     snippets/size-guide.liquid). Nada se pide al cargar: el primer clic abre el panel en "Cargando", pide la página
     de la política en el idioma actual (el href del enlace) y deja en el panel solo .shopify-policy__body; los
     siguientes clics ya no la piden. Si falla, navega a la política. Ctrl/Cmd/Mayús + clic: el enlace normal. */
  function setupPolicyPanel() {
    var panel = document.getElementById('SomniaPolicyDrawer');
    var links = document.querySelectorAll('[data-somnia-policy-link]');
    if (!panel || !links.length || !(window.theme && theme.Drawers)) return;
    var body = panel.querySelector('[data-somnia-policy-body]');
    var drawer = null;
    var requested = false;
    links.forEach(function (link) {
      link.addEventListener('click', function (evt) {
        if (evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
        evt.preventDefault();
        /* Sin esto, el clic llega a window y el cierre por clic fuera del panel lo cierra al instante */
        evt.stopPropagation();
        if (!drawer) drawer = new theme.Drawers('SomniaPolicyDrawer', 'somnia-policy');
        drawer.open(null, link);
        /* Cada vez que abre, empieza arriba (el panel recuerda su scroll al cerrarse) */
        body.scrollTop = 0;
        if (requested) return;
        requested = true;
        fetch(link.href, { credentials: 'same-origin' }).then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        }).then(function (html) {
          var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-policy__body');
          if (!src) throw new Error('policy');
          body.innerHTML = src.innerHTML;
          body.removeAttribute('aria-busy');
        }).catch(function () {
          window.location.href = link.href;
        });
      });
    });
    /* Deslizar hacia abajo desde la manija (móvil) cierra, como en la guía de tallas */
    var handle = panel.querySelector('[data-somnia-policy-handle]');
    var closeBtn = panel.querySelector('.js-drawer-close');
    var startY = null;
    handle.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; }, { passive: true });
    handle.addEventListener('touchmove', function (e) {
      if (startY !== null && e.touches[0].clientY - startY > 70) { startY = null; closeBtn.click(); }
    }, { passive: true });
    handle.addEventListener('touchend', function () { startY = null; });
  }

  /* 7. Galería: solo la foto principal carga de inmediato (es la imagen LCP); las demás van lazy
     (snippets/product-images.liquid). En el carrusel, las que están lejos no se piden hasta que deslizas cerca
     (en Safari, menos aún por adelantado): llegan tarde, sobre el fondo gris y con el fade-in del tema. Cuando la
     página termina de cargar, se piden y decodifican las demás en segundo plano, sin competir con la principal. */
  function preloadGallery() {
    var imgs = document.querySelectorAll('.product__main-photos img[loading="lazy"]');
    if (!imgs.length) return;
    var go = function () {
      imgs.forEach(function (img) {
        img.loading = 'eager';
        if (img.decode) img.decode().catch(function () {});
      });
    };
    var later = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 1500 });
      else setTimeout(go, 300);
    };
    if (document.readyState === 'complete') later();
    else window.addEventListener('load', later, { once: true });
  }

  function init() {
    setupPolicyPanel();
    preloadGallery();
    document.querySelectorAll('[data-section-type="product"]').forEach(function (section) {
      setupFaqLinks(section);
      var applyStock = setupStock(section);
      var inst = productInstance(section);
      if (applyStock && inst && inst.variants) applyStock(inst.variants.currentVariant);
      syncSoldOut(section);
      var needsChoice = !!section.querySelector('fieldset[data-somnia-size-required]');
      section.addEventListener('variantChange', function (evt) {
        if (applyStock) applyStock(evt.detail.variant);
        syncSoldOut(section);
        /* Con talla obligatoria lo hace setupSizeChoice, que sabe si ya hay talla */
        if (!needsChoice) syncStockBlock(section, true);
      });
      setupSizeChoice(section);
      setupTabs(section);
    });
  }

  if (window.theme && theme.sections) {
    init();
  } else {
    document.addEventListener('page:loaded', init, { once: true });
  }
})();
